export { default } from './BoardPagination';
